export default {
      id: "thematic-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#thematic",
      toString: function () {
        return this.url;
      }
    }